import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { DATE_FORMAT } from '@shared/constants/date-format.constant';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { ThemeService } from '@shared/services/theme.service';
import { CustomPaginator } from '@shared/utils/pagination-configuration';
import { ptBR } from 'date-fns/locale';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { routes } from './app.routes';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';

registerLocaleData(localePt);

moment.locale('pt-br');

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimations(),
    provideDateFnsAdapter(DATE_FORMAT),
    provideEnvironmentNgxMask(),
    provideLottieOptions({
      player: () => player,
    }),
    { provide: MAT_DATE_LOCALE, useValue: ptBR },
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        animation: 'pulse',
        loadingText: 'O conteúdo está sendo carregado!'
      },
    }),
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR'
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMAT
    },
    {
			provide: MatPaginatorIntl,
			useClass: CustomPaginator,
		},
    ThemeService
  ]
};
